import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { provideStore } from 'redux-vuex';
import store from './store';
import actions from './actions';

loadFonts()

const app = createApp(App)
  .use(router)
  .use(vuetify);

provideStore({
  app,
  store,
  actions,
});


app.mount('#app');
